<template>
  <div class="suport-wrapper">
    <div class="suport-center">
      <b-card class="suport-card">
        <b-card-title class="mb-1 centered" style="font-size: 1.5rem"
          ><strong>Suporte Técnico 24 Horas IT4D</strong></b-card-title
        >
        <b-card-text class="mb-2" style="font-size: 1.2rem">
          Atendimento 24 horas, incluindo sábados, domingos e feriados.<br />
          <span style="font-size: 1.1rem"
            >(21) 96598-4853
            <b-link href="https://wa.me/5521965984853" target="_blank">
              <i
                class="fab fa-whatsapp text-success"
                style="font-size: 1.5rem"
              ></i>
            </b-link>
          </span>
        </b-card-text>
      </b-card>
    </div>
  </div>
</template>

<script>
import { BCard, BCardTitle, BCardText, BLink } from "bootstrap-vue";
export default {
  components: {
    BCard,
    BCardTitle,
    BCardText,
    BLink,
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.suport-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
}
.suport-center {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.suport-card {
  min-width: 400px;
  max-width: 500px;
  padding: 2rem 2rem 1.5rem 2rem;
  box-shadow: 0 2px 24px rgba(0, 0, 0, 0.08);
}
</style>
